/* eslint-disable react/destructuring-assignment, react/no-unused-state */

import {Link, withRouter} from "react-router-dom";
import API from "../../../shared/modules/API";
import Helper from "../../../shared/modules/Helper";
import Product from "../../../shared/components/Product";
import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";
import {fetchCustomerRequests} from "../../../actions/index";
import {get} from "lodash";

class ProductRouting extends React.PureComponent {

  static propTypes = {
    "addToCartRequest": PropTypes.func.isRequired,
    "addWishListRequest": PropTypes.func.isRequired,
    "buyItNowEligible": PropTypes.bool.isRequired,
    "customerRequests": PropTypes.object.isRequired,
    "eligibleForFineJewelry": PropTypes.bool.isRequired,
    "event": PropTypes.object.isRequired,
    "fetchCustomerRequests": PropTypes.func.isRequired,
    "history": PropTypes.object.isRequired,
    "location": PropTypes.object,
    "nonMemberCartEnabled": PropTypes.bool.isRequired,
    "products": PropTypes.object.isRequired,
    "removeWishListRequest": PropTypes.func.isRequired,
    "requestsFetched": PropTypes.bool,
    "updateState": PropTypes.func.isRequired
  };

  static defaultProps = {
    "customerRequests": {},
    "eligibleForFineJewelry": false,
    "location": {},
    "requestsFetched": false
  };

  constructor (props) {
    super(props);
    $(window).scrollTop(0);

    this.state = {};
  }

  componentDidMount = () => {
    this.fetchProductFeedsAndSwatches();
  }

  componentDidUpdate = () => {
    this.fetchProductFeedsAndSwatches();
  }

  fetchProduct = (id) => {
    API.fetchProducts(
      null,
      {
        "designer": null,
        id
      }
    ).then((response) => {
      this.props.updateState(prevState => ({
        "products": Helper.createProductObject(
          [response.products],
          {
            ...prevState.products,
            [id]: {...prevState.products[id]}
          }
        )
      }));
    });
  }

  fetchProductFeedsAndSwatches = () => {
    const {event, products} = this.props;
    const {lastId} = this.state;
    const {"match": {"params": {id}}} = event;
    const {[id]: product} = products;

    if (product && product.productDescriptor) {
      if (this.state.lastId !== id) {
        this.setState({"lastId": id});
      }

      const {
        "more_by": moreBy,
        "productDescriptor": {"details": {designer}},
        recommended,
        similar
      } = product;

      if (!moreBy && !recommended && !similar && lastId !== id) {
        $.when(this.fetchProductFeeds(id, designer)).
          done(() => this.fetchSwatches(id));
      }
    } else {
      this.fetchProduct(id);
    }
  }

  productHasProductDescriptor = (product) => {
    if (product && product.productDescriptor) {
      return true;
    }
    return false;
  }

  fetchProductFeeds = (id, designer) =>
    [
      "similar",
      "recommended",
      "more_by"
    ].map(feed =>
      API.fetchProducts(feed, {
        "designerName": designer,
        id
      }).then((response) => {
        if (response && response.products && response.products.length > 0) {
          this.props.updateState(prevState => ({
            "products": Helper.createProductObject(
              response.products,
              {
                ...prevState.products,
                [id]: {
                  ...prevState.products[id],
                  [feed]: response.products.map(product => product.id)
                }
              }
            )
          }));
        }
      }));

  fetchSwatches = id =>
    Object.
      values(this.props.products[id].productDescriptor.details.natural_stone_color_groups).
      map(metalArray => metalArray.
        map(product => product.id)).
      filter(swatchId => !Object.keys(this.props.products).includes(swatchId.toString())).
      map(swatchId =>
        API.fetchProducts(null, {"id": swatchId}).then(response => this.props.updateState(prevState => (
          {"products": Helper.createProductObject([response.products], prevState.products)}
        ))));

  render () {
    const {
      addToCartRequest,
      addWishListRequest,
      buyItNowEligible,
      customerRequests,
      event,
      eligibleForFineJewelry,
      location,
      nonMemberCartEnabled,
      products,
      removeWishListRequest
    } = this.props;
    const {"match": {"params": {id}}} = event;
    const {[id]: product} = products;
    const backToResultsPath = get(location, "state.prevPath", "/jewelry");

    if (this.productHasProductDescriptor(product)) {
      const {
        "more_by": moreBy,
        recommended,
        similar
      } = product;
      const wishlisted = customerRequests[id] && customerRequests[id].statuses.includes("pending");

      return (
        <div>
          <div className="back-to-result-div ml24">
            <div className="back-to-result-link">
              <Link
                to={backToResultsPath}
              >
                {"< Back to Results"}
              </Link>
            </div>
          </div>
          <Product
            {...product}
            addToCartRequest={addToCartRequest}
            addWishListRequest={addWishListRequest}
            buyItNowEligible={buyItNowEligible}
            eligibleForFineJewelry={eligibleForFineJewelry}
            more_by={(moreBy || []).map(innerId => products[innerId])}
            nonMemberCartEnabled={nonMemberCartEnabled}
            recommended={(recommended || []).map(innerId => products[innerId])}
            removeWishListRequest={removeWishListRequest}
            similar={(similar || []).map(innerId => products[innerId])}
            wishlisted={wishlisted}
          />
        </div>);
    }

    return null;
  }
}

const mapStoreToProps = store => ({
  "buyItNowEligible": store.buyItNowEligible,
  "customerRequests": store.customerRequests
});

export default withRouter(connect(mapStoreToProps, {fetchCustomerRequests})(ProductRouting));
